"use strict";
/**
 * This code was AUTOGENERATED using the kinobi library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun kinobi to update it.
 *
 * @see https://github.com/metaplex-foundation/kinobi
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getReservationSerializer = void 0;
const serializers_1 = require("@metaplex-foundation/umi/serializers");
function getReservationSerializer() {
    return (0, serializers_1.struct)([
        ['address', (0, serializers_1.publicKey)()],
        ['spotsRemaining', (0, serializers_1.u64)()],
        ['totalSpots', (0, serializers_1.u64)()],
    ], { description: 'Reservation' });
}
exports.getReservationSerializer = getReservationSerializer;
//# sourceMappingURL=reservation.js.map